import { loadable } from '@shared/core/loadableFromNamedExport';

export const GallerySurveyTrigger = loadable(() => import(/* webpackChunkName: "content/card/gallery-survey-trigger" */ './GallerySurveyTrigger'), 'GallerySurveyTrigger');
